import {
    IPaymentClientMethod,
    IPaymentCreditCard,
    IPaymentDirectDebit,
    IPaymentPaypal,
    PaymentClientMethod,
    PaymentCreditCard,
    PaymentDirectDebit,
    PaymentPaypal,
} from '@packlink/packlink-sdk';

import { DELETE_PAYMENT_CLIENT_METHOD, PaymentAction, SET_PAYMENT_CLIENT_METHODS } from '@store/actions';

export interface IPaymentState {
    clientMethods: IPaymentClientMethod[] | null;
}

export const initialState: IPaymentState = {
    clientMethods: null,
};

export const reducer = (state: IPaymentState = initialState, action: PaymentAction): IPaymentState => {
    const { type, payload } = action;

    switch (type) {
        case SET_PAYMENT_CLIENT_METHODS: {
            const clientMethods = payload as Array<PaymentClientMethod | undefined>;

            const clientMethodsToJson = clientMethods
                .filter((clientMethod: PaymentClientMethod | undefined) => !!clientMethod)
                .map(
                    (
                        clientMethod: PaymentCreditCard | PaymentDirectDebit | PaymentPaypal,
                    ): IPaymentCreditCard | IPaymentDirectDebit | IPaymentPaypal =>
                        clientMethod.toJSON() as IPaymentCreditCard | IPaymentDirectDebit | IPaymentPaypal,
                );

            return { ...state, clientMethods: clientMethodsToJson };
        }

        case DELETE_PAYMENT_CLIENT_METHOD: {
            const clientMethodToDelete = action.payload as PaymentClientMethod;

            const clientMethods = state.clientMethods
                ? state.clientMethods.filter((method: IPaymentClientMethod) => method.id !== clientMethodToDelete.id)
                : null;

            return { ...state, clientMethods };
        }

        default:
            return state;
    }
};
